'use client';

import { useEffect, useState } from 'react';
import { Megaphone, Plus } from 'lucide-react';
import { AdminModal } from '@/components/admin/AdminModal';
import { useToast } from '@/components/admin/Toast';
import { ClientDate } from '../ClientDate';
import type { BroadcastRow } from '../types';

export function BroadcastsPanel() {
  const { toast } = useToast();
  const [rows, setRows] = useState<BroadcastRow[]>([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ title: '', body: '' });
  const [loading, setLoading] = useState(true);

  const load = () => {
    fetch('/api/super-admin/broadcasts')
      .then((r) => r.json())
      .then((j) => setRows(j.data ?? []))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const send = async () => {
    const res = await fetch('/api/super-admin/broadcasts', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(form),
    });
    if (res.ok) {
      toast('Comunicado enviado');
      setOpen(false);
      setForm({ title: '', body: '' });
      load();
    } else {
      toast('Erro ao enviar', 'error');
    }
  };

  if (loading) return <p className="text-sm text-ink-500">A carregar...</p>;

  return (
    <div className="space-y-4">
      <div className="sa-toolbar">
        <p className="text-sm text-ink-500">Mensagens para administradores de restaurantes.</p>
        <button type="button" onClick={() => setOpen(true)} className="btn btn-sm bg-brand text-white">
          <Plus className="w-4 h-4" /> Novo comunicado
        </button>
      </div>

      <div className="space-y-3">
        {rows.length === 0 ? (
          <p className="text-sm text-ink-500">Nenhum comunicado ainda.</p>
        ) : (
          rows.map((b) => (
            <article key={b.id} className="sa-card">
              <div className="flex items-start gap-3">
                <Megaphone className="w-5 h-5 text-brand flex-shrink-0 mt-0.5" />
                <div>
                  <h3 className="font-semibold text-ink-900">{b.title}</h3>
                  <p className="text-sm text-ink-600 mt-1 whitespace-pre-wrap">{b.body}</p>
                  <p className="text-xs text-ink-500 mt-2">
                    {b.created_by_email} · <ClientDate value={b.sent_at} />
                  </p>
                </div>
              </div>
            </article>
          ))
        )}
      </div>

      <AdminModal open={open} onClose={() => setOpen(false)} title="Novo comunicado"
        footer={
          <div className="flex justify-end gap-2">
            <button type="button" onClick={() => setOpen(false)} className="btn btn-secondary btn-sm">Cancelar</button>
            <button type="button" onClick={send} className="btn btn-sm bg-brand text-white">Enviar</button>
          </div>
        }
      >
        <div className="space-y-3">
          <input className="input-field" placeholder="Titulo" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} />
          <textarea className="input-field min-h-[120px]" placeholder="Mensagem..." value={form.body} onChange={(e) => setForm({ ...form, body: e.target.value })} />
        </div>
      </AdminModal>
    </div>
  );
}
